export default __webpack_public_path__ + "static/media/sotuvchilarMaktabi.8d35a94e.png";